import { Link } from "@tanstack/react-router";
import { HeartHandshake, BookOpen, LayoutDashboard, SearchIcon, Users } from "lucide-react";
import { useMembership } from "@/hooks/useMembership";

export function BlogArticleCTA() {
  const { isMember, isAdmin } = useMembership();
  const hasMemberAccess = isMember || isAdmin;
  const items = hasMemberAccess
    ? [
        {
          to: "/dashboard",
          icon: LayoutDashboard,
          title: "Go to your Dashboard",
          desc: "Your tools, journeys, journal and community — all in one place.",
        },
        {
          to: "/library",
          icon: BookOpen,
          title: "Explore the Recovery Library",
          desc: "Members-only guides, workbooks and worksheets for deeper practice.",
        },
        {
          to: "/therapists",
          icon: SearchIcon,
          title: "Find a trauma-informed therapist",
          desc: "Browse independent therapists who understand complex trauma.",
        },
        {
          to: "/community",
          icon: Users,
          title: "Join the community",
          desc: "Connect with other survivors in a moderated, private space.",
        },
      ] as const
    : [
        {
          to: "/choose-membership",
          icon: HeartHandshake,
          title: "Join Recovery Trauma™",
          desc: "Become a member and get access to the full survivor-led platform.",
        },
        {
          to: "/library",
          icon: BookOpen,
          title: "Explore the Recovery Library",
          desc: "Members-only guides, workbooks and worksheets for deeper practice.",
        },
        {
          to: "/therapists",
          icon: SearchIcon,
          title: "Find a trauma-informed therapist",
          desc: "Browse independent therapists who understand complex trauma.",
        },
        {
          to: "/community",
          icon: Users,
          title: "Join the community",
          desc: "Connect with other survivors in a moderated, private space.",
        },
      ] as const;
  return (
    <div className="mt-12 rounded-2xl border border-border bg-muted/30 p-6 sm:p-8">
      <h2 className="text-xl font-semibold text-foreground">Keep going with Recovery Trauma™</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Wellbeing is not something you do alone. Here's what's next.
      </p>
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {items.map((i) => {
          const Icon = i.icon;
          return (
            <Link
              key={i.to}
              to={i.to}
              className="group flex items-start gap-3 rounded-xl border border-border bg-background p-4 transition hover:border-primary/40 hover:bg-primary/5"
            >
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                <Icon className="h-4 w-4" />
              </span>
              <span>
                <span className="block text-sm font-semibold text-foreground group-hover:text-primary">
                  {i.title}
                </span>
                <span className="mt-0.5 block text-xs text-muted-foreground">{i.desc}</span>
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
